import PaymentDash from "../../components/dashboard/payment/PaymentDash";

function Payment() {
  return <PaymentDash />;
}

export default Payment;
